// Deprecated, removed in the next major release (see docs/major-release.md).
// Consumers should target the wds- classes instead (e.g. wds-radio__dot-container).
const semanticClassNames = {
  icon: 'radio__icon',
} as const;

export { semanticClassNames };
